import { ReactNode } from "react"
import { styled } from "@mui/material/styles"
import Card from "@mui/material/Card"

export default function CustomCard({ children }: { children: ReactNode }) {
  return (
    <StyledCard>
      {children}
    </StyledCard>
  )
}

const StyledCard = styled(Card)(({ theme }) => ({
  width: "100%",
  borderRadius: "16px",
  boxShadow: `0 0 10px 0 ${theme.palette.primary["2"]}`,
  padding: "14px"
}))
